import type { Row } from "./types";

export function getQuarterFromYYYYMM(value: unknown): string | null {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 190001) return null;
  const year = Math.floor(n / 100);
  const month = n % 100;
  if (month < 1 || month > 12) return null;
  return `Q${Math.ceil(month / 3)} ${year}`;
}

export function matchesPeriod(row: Row, period: string | null): boolean {
  if (!period) return true;
  return getQuarterFromYYYYMM(row.reporting_date) === period;
}

export function getPreviousPeriodLabel(
  periodsForFund: string[],
  selectedPeriod: string | null,
): string | null {
  if (periodsForFund.length === 0 || !selectedPeriod) return null;
  const idx = periodsForFund.indexOf(selectedPeriod);
  if (idx < 0) return null;
  return periodsForFund[idx + 1] ?? null;
}

export function quarterLabelToYYYYMM(period: string | null): number | null {
  if (!period) return null;
  const match = /^Q([1-4])\s+(\d{4})$/.exec(period.trim());
  if (!match) return null;
  const quarter = Number(match[1]);
  const year = Number(match[2]);
  return year * 100 + quarter * 3;
}
